/** Tempo que a porta leva para sair da carroceria depois de retirada. */
export const DURACAO_SAIDA_PORTA_S = 1.1

export interface PoseSaidaPorta {
  /** No referencial do veículo: para fora, para baixo e para a traseira. */
  deslocamento: [number, number, number]
  giroY: number
  giroZ: number
}

const AFASTAMENTO_LATERAL = 1.6
const QUEDA = 0.45
const RECUO = 0.3
const GIRO_Y = 0.5
const GIRO_Z = 0.28

function limitar(valor: number, minimo: number, maximo: number): number {
  return Math.min(maximo, Math.max(minimo, valor))
}

/**
 * Pose da porta já retirada, em função do progresso da saída.
 *
 * Retirar a porta era o único passo do exercício sem resposta visual: a peça
 * simplesmente deixava de ser desenhada, de um quadro para o outro. Aqui ela
 * se desprende da coluna e é levada para fora — o registro de que a abertura
 * foi conquistada, e não de que a porta evaporou.
 *
 * A aceleração é crescente (t²) de propósito: começa lenta, como quem solta a
 * peça das dobradiças, e termina rápida, como quem a carrega para longe. Sair
 * de cena em movimento disfarça o instante em que ela para de ser desenhada.
 *
 * O deslocamento é no referencial do veículo, então num veículo tombado ou
 * capotado a porta sai "para baixo" em relação à carroceria, não à gravidade
 * do mundo. Acertar isso pede a composição de `posto` que
 * `enquadramentoOficina.ts` faz, e só vale a pena com física de peça solta.
 */
export function poseSaidaDaPorta(progresso: number, lado: 'esquerdo' | 'direito'): PoseSaidaPorta {
  const t = limitar(progresso, 0, 1) ** 2
  const sinal = lado === 'esquerdo' ? 1 : -1

  return {
    deslocamento: [sinal * AFASTAMENTO_LATERAL * t, -QUEDA * t, -RECUO * t],
    giroY: sinal * GIRO_Y * t,
    giroZ: -sinal * GIRO_Z * t,
  }
}
